import React from 'react';
import { Droplet, Grid, Package } from 'lucide-react';

/**
 * Компонент выбора материалов и типа проекта
 */
const MaterialSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  projectTypes,
  concreteGrades,
  reinforcementTypes
}) => {
  return (
    <div className="mb-6 bg-emerald-50 dark:bg-emerald-900/20 p-4 rounded-lg border border-emerald-100 dark:border-emerald-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Droplet className="w-5 h-5 mr-2 text-emerald-500" />
        Материалы и тип конструкции
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Тип строительного проекта */}
        <div>
          <label htmlFor="projectType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Тип конструкции
          </label>
          <select
            id="projectType"
            name="projectType"
            value={formData.projectType}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            {projectTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
          {errors.projectType && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.projectType}
            </p>
          )}
        </div>

        {/* Марка бетона */}
        <div>
          <label htmlFor="concreteGrade" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Марка бетона
          </label>
          <select
            id="concreteGrade"
            name="concreteGrade"
            value={formData.concreteGrade}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            {concreteGrades.map((grade) => (
              <option key={grade.id} value={grade.id}>
                {grade.name} - {grade.purpose}
              </option>
            ))}
          </select>
          {errors.concreteGrade && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.concreteGrade}
            </p>
          )}
        </div>

        {/* Тип армирования */}
        <div>
          <label htmlFor="reinforcementType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Тип армирования
          </label>
          <select
            id="reinforcementType"
            name="reinforcementType"
            value={formData.reinforcementType}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            {reinforcementTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
          {errors.reinforcementType && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.reinforcementType}
            </p>
          )}
        </div>

        {/* Плотность армирования (показывается только если выбрано армирование) */}
        {formData.reinforcementType !== 'none' && (
          <div>
            <label htmlFor="reinforcementDensity" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Плотность армирования
            </label>
            <select
              id="reinforcementDensity"
              name="reinforcementDensity"
              value={formData.reinforcementDensity}
              onChange={handleInputChange}
              className="form-select w-full"
            >
              <option value="light">Легкое (шаг 30 см)</option>
              <option value="standard">Стандартное (шаг 20 см)</option>
              <option value="heavy">Усиленное (шаг 15 см)</option>
            </select>
            {errors.reinforcementDensity && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.reinforcementDensity}
              </p>
            )}
          </div>
        )}
      </div>

      {/* Информация о марке бетона */}
      {formData.concreteGrade && (
        <div className="mt-4 bg-white dark:bg-gray-700 p-3 rounded border border-emerald-100 dark:border-emerald-800">
          <div className="flex items-start space-x-3">
            <Package className="w-5 h-5 text-emerald-500 flex-shrink-0 mt-0.5" />
            <div>
              <h4 className="text-sm font-medium text-gray-800 dark:text-white">
                {concreteGrades.find(grade => grade.id === formData.concreteGrade)?.name || ''}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-300 mt-1">
                {concreteGrades.find(grade => grade.id === formData.concreteGrade)?.description || ''}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Информация о типе армирования */}
      {formData.reinforcementType !== 'none' && (
        <div className="mt-3 bg-white dark:bg-gray-700 p-3 rounded border border-emerald-100 dark:border-emerald-800">
          <div className="flex items-start space-x-3">
            <Grid className="w-5 h-5 text-emerald-500 flex-shrink-0 mt-0.5" />
            <div>
              <h4 className="text-sm font-medium text-gray-800 dark:text-white">
                {reinforcementTypes.find(type => type.id === formData.reinforcementType)?.name || ''}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-300 mt-1">
                {reinforcementTypes.find(type => type.id === formData.reinforcementType)?.description || ''}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MaterialSection;